import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  @ViewChild('loginSection') loginSection!: ElementRef;
  
  constructor(private router: Router) {}

  goToApp() {
    console.log('Navigation vers /app');
    this.router.navigate(['/app']).then(success => {
      console.log('Navigation réussie:', success);
    }).catch(error => {
      console.error('Erreur de navigation:', error);
    });
  }

  scrollToLogin() {
    if (this.loginSection) {
      this.loginSection.nativeElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'center'
      });
    }
  }
}
